import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextAreaFieldComponent } from './text-area-field.component';
import { ValidationErrorsModule } from '../validation-errors/validation-errors.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgZorroIconModule } from 'src/app/modules/nz-icon-antd.module';
import { NgZorroAntdModule } from 'src/app/modules/nz-zorro-antd.module';



@NgModule({
  declarations: [TextAreaFieldComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    NgZorroIconModule,
    ReactiveFormsModule,
    ValidationErrorsModule
  ],
  exports: [
    TextAreaFieldComponent
  ]
})
export class TextAreaFieldModule { }
